// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ContinentMapConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import cfgFactories from 'share/factories/Izenda.ReportPartStyleConfigurationFactories';
import localizer from 'share/localization/Izenda.Localizer';

import HighmapOptionsBuilder from 'share/components/charting/highcharts/Izenda.HighmapOptionsBuilder';
import CommonMapOptionsMapping from './Izenda.CommonMapOptionsMapping';
import DefaultMapContainersSchema from './Izenda.DefaultMapContainersSchema';

import { REPORT_PART_TYPE } from 'logic/data/Izenda.ReportDesignerConstants';
import { MAP_TYPES } from 'logic/data/Izenda.ReportPartMapConstants';

cfgFactories.extendConfiguration(REPORT_PART_TYPE.Map, MAP_TYPES.Continent, null, {
  get visualLabel() {
    return localizer.getText('REPORT_PART_MAP_CONSTANTS_CONTINENT');
  },

  optionsBuilder: HighmapOptionsBuilder,

  fieldContainerSchema: DefaultMapContainersSchema,

  optionsMapping: CommonMapOptionsMapping
});



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartMap/Izenda.ContinentMapConfiguration.js